import * as React from 'react';
import { Button } from '@mc/react-core';
import classNames from 'classnames';

const ClassNameNS = 'app-button-icon';
const ClassName = ` ${ClassNameNS}`;

type Props = Omit<
  React.ComponentProps<typeof Button>,
  'active' | 'fill' | 'intent' | 'outlined' | 'rightIcon' | 'icon' | 'children'
> & { icon?: JSX.Element; children?: JSX.Element; href?: string };

export class IconButton extends React.PureComponent<Props> {
  render() {
    const { className, icon, children, ...other } = this.props;

    return (
      <Button
        className={classNames(className, ClassName)}
        icon={icon ? icon : children}
        {...other}
      />
    );
  }
}
